import React from 'react';
import Chart from 'react-google-charts';
import PropTypes from 'prop-types';

import { Heading, Text } from '../../Elements/Elements';
import { smallArea } from './config';

import classes from './Area.module.scss';

const Area = ({ areaChartData }) => {
  const { title, contentText, arr, keyName = 'arr', color = 1 } = areaChartData;

  const columns = [
    {
      type: 'number',
      label: 'day'
    },
    {
      label: 'AttentionSpan',
      type: 'number'
    }
  ];

  if (color === 1) {
    smallArea.colors = ['#6fcdcd'];
  } else if (color === -1) {
    smallArea.colors = ['#e46086'];
  } else {
    smallArea.colors = ['#fbdf9c'];
  }

  const rows = [];
  if (typeof arr !== 'undefined' && arr !== null) {
    if (arr.length < 12) {
      arr.map((item, index) => {
        rows.push([index + 2, item[keyName]]);
        return '';
      });
      keyName === 'arr' && rows.splice(0, 0, [1, 0]);
    } else {
      arr.map((item, index) => {
        rows.push([index + 1, item[keyName]]);
        return '';
      });
    }
  }

  return (
    <section className={classes.box}>
      <Heading>{title}</Heading>
      <Text weight="b" className={classes.content}>
        {contentText}
      </Text>
      <div className={classes.chart}>
        <Chart
          chartType="AreaChart"
          width="101%"
          height="80px"
          legendToggle
          rows={rows}
          columns={columns}
          options={smallArea}
        />
      </div>
    </section>
  );
};

Area.propTypes = {
  areaChartData: PropTypes.shape({
    title: PropTypes.string,
    contentText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.number,
    arr: PropTypes.array,
    keyName: PropTypes.string
  })
};

export default Area;
